import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FormState} from '../../../models';

@Component({
  selector: 'app-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormActionsComponent implements OnInit {
  @Input() isDisabled = true;
  @Output() submitForm: EventEmitter<FormState> = new EventEmitter<FormState>();
  @Output() onPreview: EventEmitter<boolean> = new EventEmitter<boolean>();
  formState = FormState;

  constructor() {
  }

  ngOnInit() {
  }

  onSubmitForm() {
    this.submitForm.emit();
  }
  onPreviewClick() {
    this.onPreview.emit(true);
  }
}
